import {
  fetchJsonData,
  fetchJsonRawReponse,
  postJsonData,
  postJsonRawResponse,
} from '../../../global/data/service'
import { getItem } from '../../../global/data/synch-storage'
import { isLocal } from '../../../global/environments'
import {
  getApiTokenUrl,
  getClientId,
  getClientSecret,
} from '../../../global/environments/config'
import {
  getApiToken,
  getChangePassword,
  getForgotPassword,
  getForgotPasswordMfaAnswer,
  getForgotPasswordMfaAnswerError,
  getMfaAnswerResponse,
  getMfaAnswerResponseError,
} from '../../Login/Data/response-mock.js'

const LOCAL_DEBUG = true

export function fetchToken() {
  const headers = {
    Accept: 'application/json',
    clientId: getClientId(),
    clientSecret: getClientSecret(),
  }

  const url = getApiTokenUrl()
  if (isLocal() && LOCAL_DEBUG) {
    return getApiToken()
  } else {
    return fetchJsonRawReponse(url, headers)
  }
}

export function createUserSessionState() {
  const url = '/wam/api/user/session/state'
  return fetchJsonData(url, getApiTokenHeaders())
}

export function checkInternalSessionValid() {
  const apiToken = getItem('apiToken')
  const headers = {
    Accept: 'application/json',
    'Content-type': 'application/json',
    apitoken: apiToken,
  }

  const url = '/api/secure/noop'

  return fetchJsonRawReponse(url, headers)
}

export function postMFAAnswer(options) {
  const headers = getHeaders()

  options?.activityType && (headers['act_type'] = options.activityType)

  const url = '/advexp.svc/mfaAnswer'

  if (isLocal() && LOCAL_DEBUG) {
    if (options?.data.otp === '123') {
      return getMfaAnswerResponse()
    } else if (options?.data.answer === 'abc') {
      return getMfaAnswerResponse()
    } else {
      return getMfaAnswerResponseError(
        options?.data.answer || options?.data.otp
      )
    }
  } else {
    return postJsonRawResponse(url, options?.data, headers)
  }
}

export function postForgotPassword(data) {
  const url = '/adv.svc/forgotpassword'

  const headers = {
    Accept: 'application/json',
    'Content-type': 'application/json',
    deviceid: window?.getDeviceId(),
    action: 'forgotUid',
  }

  if (isLocal() && LOCAL_DEBUG) {
    return getForgotPassword(data.id)
  } else {
    return postJsonRawResponse(url, data, headers)
  }
}

/**
 * I guess the forgot password flow will use a different service.
 * sigh...
 */
export function postMFAAnswerFromForgotPassword(options) {
  const url = '/adv.svc/forgotpassword'

  const apiToken = getItem('apiToken')

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    deviceid: window?.getDeviceId(),
    action: 'forgotPwd',
    apitoken: apiToken,
    'X-Requested-With': 'XMLHttpRequest',
  }

  const forotPasswordRequestData = {
    id: options?.loginInput,
    idContext: 'USERID',
    deviceSignature: window?.getDeviceSignature(),
    otp: options?.data.otp,
  }

  if (isLocal() && LOCAL_DEBUG) {
    if (options?.data.otp === '123') {
      return getForgotPasswordMfaAnswer()
    } else {
      return getForgotPasswordMfaAnswerError()
    }
  } else {
    return postJsonRawResponse(url, forotPasswordRequestData, headers)
  }
}

/**
 * Calls WAM directly, don't need to be orchestrated
 */
export function postResetPassword(data) {
  const headers = getHeaders()

  const url = '/advexp.svc/changePassword'
  if (isLocal() && LOCAL_DEBUG) {
    return getChangePassword()
  } else {
    return postJsonData(url, data, headers)
  }
}

/**
 * Calls the wrapper service, since we need cmsession set from this
 * PUT now changed to a POST
 * @param {*} data
 * @returns
 */
export function putResetPassword(data, orchestrated) {
  const headers = getHeaders()

  // if its not orchestrated, we are calling change password straight up
  // orchestration layer doesn't need this in the header
  if (!orchestrated) {
    headers.action = 'changePwd'
  }

  const url = '/advexp.svc/changePassword'
  if (isLocal() && LOCAL_DEBUG) {
    return getChangePassword()
  } else {
    return postJsonData(url, data, headers)
  }
}

function getApiTokenHeaders() {
  const apiToken = getItem('apiToken')

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    apitoken: apiToken,
  }

  return headers
}

function getHeaders() {
  const apiToken = getItem('apiToken')

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    apitoken: apiToken,
    deviceid: window?.getDeviceId(),
    'X-Requested-With': 'XMLHttpRequest',
  }

  return headers
}
